import { LIST as LIST_MUTATIONS } from "../mutations";
import { LIST as LIST_ACTIONS } from "../actions";
import Vue from "vue";

const state = {
	loading: false, //是否正在发起获取权限的请求
	is_request: false, //是否已经向后端发起过请求
	place_type_list: [], 
	community_list: [], 
	street_list: [], 
};

const getters={}


const mutations = {
	//修改加载状态
	[LIST_MUTATIONS.SET_LOADING](state, loading) {
		state.loading = loading;
	},

	//修改请求状态
	[LIST_MUTATIONS.SET_IS_REQUEST](state, is_request) {
		state.is_request = is_request;
	},

	[LIST_MUTATIONS.SET_COMMUNITY_LIST](state, list) {
		state.community_list = list;
	},

	[LIST_MUTATIONS.SET_STREET_LIST](state, list) {
		state.street_list = list;
	},

	[LIST_MUTATIONS.SET_PLACE_TYPE_LIST](state, list) {
		state.place_type_list = list;
	},
};

const actions = {
	[LIST_ACTIONS.REQUEST_LIST]({ commit }) {
		commit(LIST_MUTATIONS.SET_LOADING, true);
		return new Promise((resolve, reject) => {
			Vue.$_invoke("place_getSearchData")
				.then((res) => {
					const { street_list, community_list,place_type_list } = res;
					commit(LIST_MUTATIONS.SET_STREET_LIST, street_list);
					commit(LIST_MUTATIONS.SET_COMMUNITY_LIST, community_list);
                    commit(LIST_MUTATIONS.SET_PLACE_TYPE_LIST, place_type_list);
					commit(LIST_MUTATIONS.SET_LOADING, false);
					commit(LIST_MUTATIONS.SET_IS_REQUEST, true);
					resolve(res);
				})
				.catch((e) => {
					reject(e);
				})
				.finally(() => {
					commit(LIST_MUTATIONS.SET_LOADING, false);
				});
		});
	},
};

export default {
	namespaced: true,
	getters,
	state,
	mutations,
	actions,
};
